import { Injectable } from '@angular/core';

import { GlobalTax } from '../../models/global-tax';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class GlobalTaxService {
  private url: string = 'global_taxes';

  constructor(private httpClient: HttpClientService) {}

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  save(globalTax: GlobalTax): Promise<any> {
    if (globalTax.id) return this.httpClient.put(`${this.url}/${globalTax.id}.json`, { global_tax: globalTax });
    else return this.httpClient.post(`${this.url}.json`, { global_tax: globalTax });
  }
}
